import React, { useState, useEffect, useRef } from "react";
import ApiClient from "../services/api-client"
import { useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import IFramePrintTemplate from '../components/iframe-print-template.component';
import { ChromePicker } from "react-color";
import BlockUi from '@availity/block-ui';
import FormLayout from '../components/layout/form-layout'
import { useForm } from "react-hook-form";
import { CustomConfirmAlert as confirmAlert } from '../components/custom-confirm-alert';
import { useNavigate } from 'react-router-dom'
import { toast } from 'react-toastify';
import Dropzone from 'react-dropzone-uploader'
import default_logo from '../img/default.png';
import ReactDOM from 'react-dom';
import AceEditor from "react-ace";
import Slider from 'rc-slider';
import "ace-builds/src-noconflict/mode-css";
import "ace-builds/src-noconflict/ext-language_tools";
import "ace-builds/src-noconflict/theme-dracula";
import reactCSS from 'reactcss'
import Tippy from '@tippyjs/react';
import useStore from "../hooks/useStore";

export default function InvoiceView(props) {

    const { t } = useTranslation();
    const iframePrintTemplate = useRef();
    const [extracss, setExtracss] = useState();
    const default_main_color = "#013289"
    const default_secondary_color = "#FFFFFF"
    const [template, setTemplate] = useState({});
    const { id } = useParams();
    const navigate = useNavigate();

    const [blockuiLoading, setBlockuiLoading] = useState(false);
    const refDropZone = useRef();
    const [logoPath, setLogoPath] = useState();
    const [pathPreview, setPathPreview] = useState(default_logo);
    const [logoFile, setLogoFile] = useState();
    const [zoomValue, setZoomValue] = useState(100);
    const [displayMainColorPicker, setDisplayMainColorPicker] = useState(false);
    const [displaySecondaryColorPicker, setSecondaryMainColorPicker] = useState(false);

    const { register, handleSubmit, setValue, reset, methods, formState: { errors }, clearErrors } = useForm();

    useEffect(() => {

        var dummyPrintSale = iframePrintTemplate.current.getPrintDesign();

        setBlockuiLoading(true)

        var company = useStore.getState().selectedCompany

        var companyId = company.id;
        ApiClient.getTemplateSettings(companyId, id).then(
            response => {

                var _template = response.data;

                _template.template = _template.template ? _template.template : "simple_template";
                _template.mainColor = _template.mainColor ? _template.mainColor : default_main_color;
                _template.secondaryColor = _template.secondaryColor ? _template.secondaryColor : default_secondary_color;
                _template.appFont = _template.appFont ? _template.appFont : "Arial";

                setValue("template", _template.template)
                setValue("css", _template.css);
                setValue("appFont", _template.appFont);
                setValue("iban", _template.iban);
                setValue("moreInfo", _template.moreInfo);


                setTemplate(_template)
                if (_template.logo) {
                    setLogoPath(_template.logo + "?" + Math.random())
                    dummyPrintSale.LOGO = _template.logo + "?" + Math.random();
                }
                loadCss(_template.css)
                dummyPrintSale.IBAN = _template.iban;
                dummyPrintSale.MOREINFO = _template.moreInfo;
                iframePrintTemplate.current.setPrintSale(dummyPrintSale);
                setBlockuiLoading(false)

            },
            error => {
                setBlockuiLoading(false)
                console.error(
                    (error.response &&
                        error.response.data &&
                        error.response.data.message) ||
                    error.message ||
                    error.toString())
            }
        );
    }, []);

    var timeout;

    const onCssInputChange = (val) => {
        setExtracss(val);
        setTemplate(template => ({
            ...template,
            ...{ css: val }
        }));
    }

    function loadCss(css) {

        if (timeout) clearTimeout(timeout);
        timeout = setTimeout(function () {
            setExtracss(css)
        }, 1000)
    }

    const onChangeIbanHandler = (e) => {
        var val = e.target.value;
        setTemplate(template => ({
            ...template,
            ...{ iban: val }
        }));

    }
    const onChangeMoreInfoHandler = (e) => {
        var val = e.target.value;
        setTemplate(template => ({
            ...template,
            ...{ moreInfo: val }
        }));

    }

    const handleChangeMainComplete = (color) => {
        setTemplate(template => ({
            ...template,
            ...{ mainColor: color.hex }
        }));

    }
    const handleChangeSecondaryComplete = (color) => {
        setTemplate(template => ({
            ...template,
            ...{ secondaryColor: color.hex }
        }));

    }
    const onChangeTemplateHandler = (e) => {
        var val = e.target.value;
        setTemplate(temp => ({
            ...temp,
            ...{ template: val }
        }));
    }

    const onSubmit = (templateObj, e) => {
        e.preventDefault();

        document.getElementById("clearLogo").style.display = "unset"
        var company = useStore.getState().selectedCompany

        templateObj.branch = {
            id: id
        }

        templateObj.logo = document.getElementById("preview").src;

        if (templateObj.logo) {
            templateObj.logo = templateObj.logo.split("?")[0]
        }
        if (templateObj.logo.includes("static/media/default") || templateObj.logo.includes("data:image/png;base64")) {
            templateObj.logo = null;
        }

        let formData = new FormData();
        var file = new File(["empty"], logoPath, {
            type: "text/plain",
        });
        var files = [];
        if (logoFile) {
            file = logoFile;
            files.push(file);
            formData.append("file", file, "name");
        }


        templateObj.mainColor = template.mainColor;
        templateObj.secondaryColor = template.secondaryColor;
        templateObj.appFont = template.appFont;
        templateObj.css = template.css;


        formData.append("template", JSON.stringify(templateObj));

        confirmAlert({
            title: t("submitConfirm"),
            message: t("areYouSure"),
            buttons: [
                {
                    label: t('Yes'),
                    className: "accept",
                    onClick: () => ApiClient.saveCompanyTemplateAndUploadFiles(company.id, formData).then(
                        response => {

                            if (id === undefined) {
                                // e.target.reset();
                                // reset();

                                navigate("/")
                                navigate("/designer");
                            }
                            toast.success(t("saveSucceded"))

                        },
                        error => {
                            console.error(error.response);
                            toast.error("Error: " + error.response.data.message);
                        }
                    )
                },
                {
                    label: t('No')
                }
            ]
        });
    }
    const onDeleteClick = e => {
        var companyId = useStore.getState().selectedCompany.id;

        e.preventDefault();
        confirmAlert({
            title: t("submitConfirm"),
            message: t("areYouSureToDelete"),
            buttons: [
                {
                    label: t('Yes'),
                    onClick: () => ApiClient.deleteCompanyTemplate(companyId, id).then(
                        response => {
                            navigate("/customers");
                            toast.success(t("deleteSucceded"))

                        },
                        error => {
                            toast.error("Error: " + error.data)
                            console.error(error.data)
                        }
                    )
                },
                {
                    label: t('No'),
                    onClick: () => { return }
                }
            ]
        });

    }
    var deleteBtn = "";
    if (id != undefined) {
        deleteBtn = <button onClick={onDeleteClick} className="btn btn-danger deletebtn">
            {t("Delete")}
        </button>
    }
    const onChangeFont = (e) => {
        var val = e.target.value;
        setTemplate(template => ({
            ...template,
            ...{ appFont: val }
        }));
    }
    const showDropZone = () => {
        // refDropZone.current.open()
        var _input = document.getElementsByClassName("dzu-input");
        if (_input.length > 0) {
            _input[0].click();
        }
    }
    const onMouseOver = e => {
        let container = ReactDOM.findDOMNode(e.target).parentNode.getElementsByTagName("input")[0];
        if (container != undefined) {
            container.focus();

        }
    }
    const handleChangeStatus = ({ meta, file }, status) => {

        if (status == "done") {
            setLogoFile(file);
            setLogoPath(meta.previewUrl);
            setPathPreview(meta.previewUrl);

            var dummyPrintSale = iframePrintTemplate.current.getPrintDesign();
            dummyPrintSale.LOGO = meta.previewUrl;
            iframePrintTemplate.current.setPrintSale(dummyPrintSale);

            document.getElementById("clearLogo").style.display = "unset"
        }
        else {
            document.getElementById("clearLogo").style.display = "none"
        }
    }
    const clearLogo = () => {
        setLogoFile(null);
        setLogoPath(null);
        setPathPreview(default_logo)
        document.getElementsByClassName("dzu-previewButton")[0].click();
    }



    const copyClipBoard = (e, elementId) => {
        var copyText = document.getElementById(elementId);
        navigator.clipboard.writeText(copyText.value);
    }

    // const st={
    //     "-ms-zoom": 0.75,
    //     "-moz-transform": scale(0.75),
    //     "-moz-transform-origin": "0 0",
    //     "-o-transform": scale(0.75),
    //     "-o-transform-origin": "0 0",
    //     "-webkit-transform": scale(0.75),
    //     "-webkit-transform-origin": "0 0"
    // }

    const hangleZoomChange = (val) => {
        setZoomValue(val);
        var el = document.getElementById('designer-frame-container');
        var h = (el.scrollHeight - el.clientHeight) / 2;
        var w = (el.scrollWidth - el.clientWidth) / 2;

        document.getElementById('designer-frame-container').scrollTop = h;
        document.getElementById('designer-frame-container').scrollLeft = w;
    }
    const styles = reactCSS({
        'default': {
            colorMain: {
                width: '36px',
                height: '14px',
                borderRadius: '2px',
                background: template.mainColor,
            },
            colorSecondary: {
                width: '36px',
                height: '14px',
                borderRadius: '2px',
                background: template.secondaryColor,
            },
            swatch: {
                padding: '5px',
                background: '#fff',
                borderRadius: '1px',
                boxShadow: '0 0 0 1px rgba(0,0,0,.1)',
                display: 'inline-block',
                cursor: 'pointer',
            },
            popover: {
                position: 'absolute',
                zIndex: '2',
            },
            cover: {
                position: 'fixed',
                top: '0px',
                right: '0px',
                bottom: '0px',
                left: '0px',
            },
        },
    });

    const handleOpenMainColorPicker = () => {
        setDisplayMainColorPicker(true)
    }
    const handleCloseMainColorPicker = () => {
        setDisplayMainColorPicker(false)
    }
    const handleOpenSecondaryColorPicker = () => {
        setSecondaryMainColorPicker(true)
    }
    const handleCloseSecondaryColorPicker = () => {
        setSecondaryMainColorPicker(false)
    }

    return (
        <BlockUi tag="div" blocking={blockuiLoading}>
            <form autoComplete="off" id="customer_form" onSubmit={handleSubmit(onSubmit)}>
                <div className="container-fluid" style={{ paddingLeft: 0, paddingRight: 0 }}>
                    <FormLayout
                        title={t('templateAdd')}
                        headerRightContent={
                            <div className="offset-md-9 col-md-3 addmodelBtnContainer">
                                <a className="btn btn-skin header-btn" onClick={() => navigate("/templates")}>
                                    {t("templateSearch")} <i className="fa fa-search"></i>
                                </a>
                            </div>
                        }
                        footer={
                            <button type="submit" className="btn btn-skin btn-lg">
                                <i className="fa fa-save" style={{ marginRight: 7 }}></i>
                                {t("Save")}
                            </button>
                        }
                    >
                        <div className="row g-2 designer-row">

                            {/* ── Left panel ── */}
                            <div className="col-md-3">
                                <div className="card left-panel-designer-card designer-side-panel">
                                    <div className="card-header">
                                        <i className="fa fa-sliders" style={{ marginRight: 8 }}></i>
                                        {t('template')}
                                    </div>
                                    <div className="card-body designer-settings-body">

                                        {/* Template selector */}
                                        <div className="form-group mb-3">
                                            <label className="control-label inputlabel">{t('template')}</label>
                                            <select
                                                name="template"
                                                {...register('template')}
                                                onChange={onChangeTemplateHandler}
                                                className="form-select form-select-sm"
                                            >
                                                <option value="simple_template">Simple Template</option>
                                                <option value="2xa5_simple_template">2×A5 Simple Template</option>
                                                <option value="glamour_template">Glamour Template</option>
                                                <option value="modern_template">Modern Template</option>
                                                <option value="flux_template">Flux Template</option>
                                                <option value="thermal_printer_template">Thermal Printer Template</option>
                                            </select>
                                        </div>

                                        {/* Logo */}
                                        <div className="form-group mb-3">
                                            <label className="control-label inputlabel">
                                                {t("companyLogo")}
                                                <small className="text-muted ms-1">({t("suggestedDims")}: 340×60 px)</small>
                                            </label>
                                            <div className="designer-logo-area" onClick={showDropZone}>
                                                <img id="preview" src={pathPreview} alt="logo preview" className="designer-logo-preview" />
                                                <div className="designer-logo-overlay">
                                                    <i className="fa fa-upload"></i>
                                                </div>
                                            </div>
                                            <button
                                                id="clearLogo"
                                                type="button"
                                                className="btn btn-outline-secondary btn-sm mt-1 w-100"
                                                style={{ display: 'none' }}
                                                onClick={clearLogo}
                                            >
                                                <i className="fa fa-times" style={{ marginRight: 5 }}></i>
                                                {t("clearLogo") || "Clear logo"}
                                            </button>
                                            <span onMouseOver={onMouseOver} style={{ display: 'none' }} className="selectCell">
                                                <Dropzone
                                                    onChangeStatus={handleChangeStatus}
                                                    maxFiles={1}
                                                    multiple={false}
                                                    ref={refDropZone}
                                                    accept="image/*"
                                                    inputContent={() => 'Click to upload logo'}
                                                    styles={{
                                                        dropzoneReject: { borderColor: 'red', backgroundColor: '#DAA' },
                                                        inputLabel: () => ({ fontSize: 14 }),
                                                    }}
                                                />
                                            </span>
                                        </div>

                                        {/* Colors */}
                                        <div className="form-group mb-3">
                                            <label className="control-label inputlabel d-block mb-2">{t("mainColor")} / {t("secondaryColor")}</label>
                                            <div className="designer-color-row">
                                                <div className="designer-color-item">
                                                    <span className="designer-color-label">{t("mainColor")}</span>
                                                    <div style={styles.swatch} onClick={handleOpenMainColorPicker}>
                                                        <div style={styles.colorMain} />
                                                    </div>
                                                    {displayMainColorPicker && (
                                                        <div style={styles.popover}>
                                                            <div style={styles.cover} onClick={handleCloseMainColorPicker} />
                                                            <ChromePicker color={template.mainColor} width="auto" onChangeComplete={handleChangeMainComplete} />
                                                        </div>
                                                    )}
                                                </div>
                                                <div className="designer-color-item">
                                                    <span className="designer-color-label">{t("secondaryColor")}</span>
                                                    <div style={styles.swatch} onClick={handleOpenSecondaryColorPicker}>
                                                        <div style={styles.colorSecondary} />
                                                    </div>
                                                    {displaySecondaryColorPicker && (
                                                        <div style={styles.popover}>
                                                            <div style={styles.cover} onClick={handleCloseSecondaryColorPicker} />
                                                            <ChromePicker color={template.secondaryColor} width="auto" onChangeComplete={handleChangeSecondaryComplete} />
                                                        </div>
                                                    )}
                                                </div>
                                            </div>
                                        </div>

                                        {/* IBAN */}
                                        <div className="form-group mb-3">
                                            <label className="control-label inputlabel">
                                                {t('iban')}
                                                <Tippy trigger="click" content={t("iban")}>
                                                    <i className="fa fa-info-circle infoicon ms-1"></i>
                                                </Tippy>
                                            </label>
                                            <textarea
                                                name="iban"
                                                {...register('iban')}
                                                className="form-control form-control-sm"
                                                rows={2}
                                                onChange={onChangeIbanHandler}
                                            />
                                        </div>

                                        {/* More info */}
                                        <div className="form-group mb-2">
                                            <label className="control-label inputlabel">
                                                {t('moreInfo')}
                                                <Tippy trigger="click" content={t("moreInfo")}>
                                                    <i className="fa fa-info-circle infoicon ms-1"></i>
                                                </Tippy>
                                            </label>
                                            <textarea
                                                name="moreInfo"
                                                {...register('moreInfo')}
                                                rows={4}
                                                className="form-control form-control-sm"
                                                onChange={onChangeMoreInfoHandler}
                                            />
                                        </div>

                                        {/* Font (hidden) */}
                                        <div style={{ display: 'none' }}>
                                            <select className="form-select" name="appFont" {...register('appFont')} onChange={onChangeFont}>
                                                <option value="Arial">Arial</option>
                                                <option value="'Open Sans'">Open Sans</option>
                                            </select>
                                        </div>

                                    </div>
                                </div>
                            </div>

                            {/* ── Center preview ── */}
                            <div className="col-md-6">
                                <div className="designer-zoom-bar">
                                    <i className="fa fa-search-minus" style={{ color: '#aaa' }}></i>
                                    <div className="designer-zoom-slider">
                                        <Slider
                                            min={40}
                                            max={100}
                                            value={zoomValue}
                                            onChange={hangleZoomChange}
                                            onChangeComplete={hangleZoomChange}
                                        />
                                    </div>
                                    <i className="fa fa-search-plus" style={{ color: '#aaa' }}></i>
                                    <span className="designer-zoom-label">{zoomValue}%</span>
                                </div>
                                <div
                                    id="designer-frame-container"
                                    className="designer-frame-container"
                                    style={{ height: (zoomValue / 100) * 320 + 'mm' }}
                                >
                                    <IFramePrintTemplate
                                        logoPath={logoPath}
                                        template={template}
                                        extracss={extracss}
                                        style={{ height: '297mm', width: '800px', transform: 'scale(' + (zoomValue / 100) + ')', transformOrigin: 'top center' }}
                                        ref={iframePrintTemplate}
                                    />
                                </div>
                            </div>

                            {/* ── Right panel — CSS editor ── */}
                            <div className="col-md-3">
                                <div className="card right-panel-designer-card designer-side-panel">
                                    <div className="card-header">
                                        <i className="fa fa-code" style={{ marginRight: 8 }}></i>
                                        {t("cssInput")}
                                    </div>
                                    <div className="card-body p-0">

                                        <AceEditor
                                            mode="css"
                                            theme="dracula"
                                            name="css"
                                            onChange={onCssInputChange}
                                            fontSize={13}
                                            width="100%"
                                            showPrintMargin={false}
                                            showGutter={false}
                                            highlightActiveLine={true}
                                            value={template ? template.css : ""}
                                            setOptions={{
                                                enableBasicAutocompletion: false,
                                                enableLiveAutocompletion: false,
                                                enableSnippets: false,
                                                showLineNumbers: true,
                                                tabSize: 2,
                                                useWorker: false,
                                            }}
                                        />

                                        <div className="designer-info-box mx-2 my-2">
                                            <i className="fa fa-info-circle" style={{ marginRight: 6 }}></i>
                                            {t("designerCssHelpInfo2")}
                                        </div>

                                        {/* Snippets */}
                                        <div className="designer-snippets">
                                            {[
                                                { id: 'snipnet3', key: 'snipnet3', rows: 3, value: `.cont_signs{\n    display:none;\n}` },
                                                { id: 'snipnet1', key: 'snipnet1', rows: 5, value: `.background_img_container {\n    background: url("image_url")\n    no-repeat center center;\n    background-size: contain;\n    opacity: 0.1;\n}` },
                                                { id: 'snipnet2', key: 'snipnet2', rows: 7, value: `.description_head_td {\n    text-indent: -9999px;\n    line-height: 0;\n}\n.description_head_td::after {\n    content: "ΥΠΗΡΕΣΙΑ";\n    text-indent: 0;\n    display: block;\n    line-height: initial;\n    height: 100%;\n}` },
                                                { id: 'snipnet4', key: 'snipnet4', rows: 3, value: `.product_table td:nth-child(3){\n    display:none;\n}` },
                                                { id: 'snipnet5', key: 'snipnet5', rows: 8, value: `.invoice-box.gb .issuer_name {\n    text-indent: -9999px;\n    line-height: 0;\n    visibility:hidden;\n}\n.invoice-box.gb .issuer_name::after {\n    content: "PrintestoreEnglish";\n    text-indent: 0;\n    display: block;\n    line-height: initial;\n    height: 100%;\n    visibility:visible;\n}` },
                                            ].map(snip => (
                                                <div className="designer-snippet-item" key={snip.id}>
                                                    <div className="designer-snippet-label">
                                                        <span>{t(snip.key)}</span>
                                                        <a href="#" onClick={e => copyClipBoard(e, snip.id)}>
                                                            <i className="fa fa-copy"></i>
                                                        </a>
                                                    </div>
                                                    <textarea
                                                        id={snip.id}
                                                        rows={snip.rows}
                                                        disabled
                                                        className="form-control cssInput designer-snippet-textarea"
                                                        defaultValue={snip.value}
                                                    />
                                                </div>
                                            ))}
                                        </div>

                                        {/* Tutorial video */}
                                        <div className="designer-video-wrap">
                                            <iframe
                                                width="100%"
                                                height="220"
                                                src="https://www.youtube.com/embed/bJchYY08_RE"
                                                title="YouTube video player"
                                                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                                                allowFullScreen
                                            />
                                        </div>

                                    </div>
                                </div>
                            </div>

                        </div>
                    </FormLayout>
                </div>
            </form>
        </BlockUi>
    );
}
